import type { FieldWidth } from '../types';

const WIDTH_PERCENT: Record<FieldWidth, number> = {
  full: 100,
  twoThirds: 200 / 3,
  half: 50,
  third: 100 / 3,
  quarter: 25,
};

/** CSS percentage for a field's configured width — defaults to 'full' when unset. */
export function fieldWidthPercent(width: FieldWidth | undefined): number {
  return WIDTH_PERCENT[width ?? 'full'];
}

export const FIELD_WIDTH_OPTIONS: { value: FieldWidth; label: string }[] = [
  { value: 'full', label: 'Full width' },
  { value: 'twoThirds', label: 'Two-thirds' },
  { value: 'half', label: 'Half' },
  { value: 'third', label: 'One-third' },
  { value: 'quarter', label: 'Quarter' },
];
